import { Route } from '@angular/router';
import { AcceptMemberInvitationComponent } from './feat-accept-member-invitation/accept-member-invitation.component';
import { memberInvitationResolver } from './member-invitation.resolver';

export const routes: Route[] = [
  {
    path: 'activation/member-invitation/accept/:activationCode',
    component: AcceptMemberInvitationComponent,
    resolve: {
      profileMemberInviteDetails: memberInvitationResolver,
    },
    data: {
      hideFooter: true,
    },
  },
];
